export default class InvalidPasswordError extends Error {
  constructor() {
    super(`Invalid password`);
  }
}
